// extracted by mini-css-extract-plugin
export default {"no_items":"no_items_no_items__EDfrB"};